import { useEffect, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useAuth } from "../../../contexts/auth";
import ShiftService from "../../../services/ShiftService";
import "./ListTurnos.css";
import { parseTimeWithTimezoneToString } from "../../../utils/date";

export function parseShift(shift) {
	return {
		id: shift.id,
		name: shift.name,
		descricao: shift.description,
		externalId: shift.externalId,
		horario_inicio: parseTimeWithTimezoneToString(shift.startTime),
		horario_fim: parseTimeWithTimezoneToString(shift.endTime),
		levels: shift.levels,
		dias_semana: Array.isArray(shift.daysOfWeek)
			? shift.daysOfWeek.join(", ")
			: shift.daysOfWeek,
		responsavel: shift.responsible?.name,
		ultima_alteracao: shift.updatedAt
			? shift.updatedAt.substring(0, 10)
			: "",
	}
}

const ListTurnos = (props) => {
	const [shifts, setShifts] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "updated_at",
		orderDirection: "DESC",
	});
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(true);

	const clientData = user.userData.selectedOrganizationId;

	const getTurnos = async (page, searchText, clientID, orderBy) => {
		setIsLoading(true);
		try {
			const response = await ShiftService.getPaginatedShifts(
				page,
				searchText,
				clientID,
				orderBy
			);
			if (response && response.data) {
				const paginated = response.data;
				const formattedShifts = paginated.items.map(parseShift);
				setShifts(formattedShifts);
				setMaxPage(paginated.pagination.totalPages);
			}
		} catch (error) {
			console.error(error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (user?.userData?.selectedOrganizationId || true) {
			getTurnos(1, props.filters, clientData, collumnClicked);
		}
	}, [user, props.filters, collumnClicked, clientData, props.refreshKey]);

	return (
		<>
			<div className="list-container list-visibility ">
				<List
					isLoading={isLoading}
					lineSelected={props.lineSelected}
					handleCollumnTitleClick={(col) => setCollumnClicked(col)}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{
							collumnLabel: "Horário de Início",
							index: "horario_inicio",
							type: "text",
						},
						{
							collumnLabel: "Horário de Fim",
							index: "horario_fim",
							type: "text",
						},
						{
							collumnLabel: "Dias da Semana",
							index: "dias_semana",
							type: "text",
						},
						{ collumnLabel: "Responsável", index: "responsavel", type: "text" },
						{
							collumnLabel: "Última Alteração",
							index: "ultima_alteracao",
							type: "text",
						},
					]}
					data={shifts}
				/>
			</div>
			<div className="card-visibility">
				{shifts.map((shift, index) => (
					<Card
						key={shift.id || index}
						data={shift}
						delete={() => { }}
						navigateOnDelete={""}
						navigateOnEdit={""}
					>
						<p className="card-content-title">{shift.name}</p>
						<p className="card-content">
							Horário de Início: {shift.horario_inicio}
						</p>
						<p className="card-content">Horário de Fim: {shift.horario_fim}</p>
						<p className="card-content">Dias da Semana: {shift.dias_semana}</p>
						<p className="card-content">Responsável: {shift.responsavel}</p>
						<p className="card-content">
							Última Alteração: {shift.ultima_alteracao}
						</p>
					</Card>
				))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getTurnos(page, props.filters, clientData.id, collumnClicked)
				}
			/>
		</>
	);
};

export default ListTurnos;
